import "../../styles/home.scss";
import { useNavigate } from "react-router";
import { BodyFull } from "./body/BodyFull";
import { BodyWaitingActivation } from "./body/BodyWaitingActivation";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/ReduxStore";
import { StatusThunk } from "../../redux/status/StatusThunk";
import { StoryStates } from "../../shared/StoryElements";
import { LoadingPage } from "../LoadingPage";
import { TutorialPopup } from "../../parts/TutorialPopup";
import { TutorialSteps } from "../../redux/tutorials/TutorialState";

export function HomePage() {
  const navigate = useNavigate();
  const statusState = useSelector((state: RootState) => state.status);
  const activationCode = useSelector(
    (state: RootState) => state.activationCode.value
  );

  const dispatch = useDispatch<AppDispatch>();

  if (!statusState.initialized && !statusState.loading) {
    dispatch(StatusThunk.currentStatus());
  }

  function generateBody() {
    if (!statusState.initialized || statusState.loading) {
      return <LoadingPage />;
    } else if (activationCode !== null) {
      // We have an activationCode set
      return <BodyWaitingActivation code={activationCode} />;
    } else if (statusState.status) {
      switch (statusState.status.state) {
        case StoryStates.COMMAND:
          return <p>Commande en cours</p>;
        case StoryStates.SENT:
          return <BodyWaitingActivation />;
        case StoryStates.ACTIVATED:
        case StoryStates.DONE:
          return <BodyFull />;
      }
    }
    // TODO Remove for BodyNoStatus and add activation code to NoStatus
    return <BodyWaitingActivation />;
  }

  return (
    <>
      <div style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {generateBody()}
      </div>

      <div
        className="columns"
        style={{
          flexShrink: 0,
          alignItems: "flex-end",
          marginBottom: "0.05rem",
        }}
      >
        <div className="is-fullwidth column">
          <TutorialPopup
            step={TutorialSteps.Parameters}
            style={{
              bottom: "8vh",
              minWidth: "300px",
              width: "50vw",
              maxWidth: "98vw",
              left: "50%",
              transform: "translate(-50%, 0)",
            }}
          >
            <p>
              Utilisez le bouton{" "}
              <b style={{ fontSize: "110%" }}> Informations </b>pour accéder à
              vos paramètres, aux mentions légales et pour relancer ce tutoriel.
            </p>
          </TutorialPopup>
          <button
            className="button is-medium is-fullwidth button-cartel-light"
            onClick={(e) => {
              e.preventDefault();
              navigate("settings");
            }}
          >
            Informations du compte
          </button>
        </div>
      </div>
    </>
  );
}
